import usePlankTableStore from '@/views/ddp/hooks/usePlankTableStore';
import useTooltipVoorraad from '@/views/ddp/hooks/useTooltipVoorraad';
import { getClaimsTotaal } from '@/views/ddp/utils/voorraadbeheer';

import VoorraadDots from '../../VoorraadBeheer/VoorraadDots';

const TabVoorraadRegionaal = () => {
  const voorraadRegionaal = usePlankTableStore((state) => state.sidepanel.voorraadRegionaal);
  const { showTooltip, updateTooltip, hideTooltip } = useTooltipVoorraad();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        overflowY: 'auto',
        scrollbarColor:
          'var(--tractie-color-background-accent-gray-default) var(--tractie-color-background-elevated-2)',
        marginBottom: '24px',
      }}
    >
      {voorraadRegionaal?.dienstregelpunten.map((voorraadMatKnoop) => (
        <div
          key={voorraadMatKnoop.dienstregelpunt}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid var(--tractie-color-border-default)',
          }}
          onMouseEnter={showTooltip(voorraadMatKnoop.dienstregelpunt, voorraadMatKnoop)}
          onMouseMove={updateTooltip(voorraadMatKnoop.dienstregelpunt, voorraadMatKnoop)}
          onMouseLeave={hideTooltip}
        >
          <div>{voorraadMatKnoop.dienstregelpunt}</div>
          <div>
            <VoorraadDots
              aantal={voorraadMatKnoop.overOfTekort}
              claimsCount={getClaimsTotaal(voorraadMatKnoop.claims)}
              beschikbareReizigersdienst={
                voorraadMatKnoop.aanwezig - voorraadMatKnoop.inzetten - voorraadMatKnoop.nietInzetbaar
              }
              nvt={voorraadMatKnoop.nvt}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
export default TabVoorraadRegionaal;
